import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp } from "lucide-react";

export default function ScrollToTop() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => { window.scrollTo({ top: 0 }); }, [pathname]);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-24 sm:bottom-6 right-5 z-40 glass-dark shadow-lg rounded-full p-3 text-[#f5f0ff] hover:text-[#ff3b3b] transition-colors"
      aria-label="Scroll to top" data-testid="scroll-to-top">
      <ArrowUp size={20} />
    </button>
  );
}
